var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.showCommentForm
    ? _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c(
            "v-col",
            { staticClass: "pt-2", attrs: { cols: "12" } },
            [
              _c("v-icon", { attrs: { color: "primary" } }, [
                _vm._v("add_comment"),
              ]),
              _vm._v(" "),
              _c("a", { on: { click: _vm.onOpen } }, [
                _vm._v("コメントを追加…"),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm.showCommentForm
    ? _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("Simplemde", {
                attrs: { rows: 3, name: "comment-body-new" },
                model: {
                  value: _vm.newComment,
                  callback: function ($$v) {
                    _vm.newComment = $$v
                  },
                  expression: "newComment",
                },
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "me-2",
                  attrs: { color: "primary" },
                  on: { click: _vm.onCreateComment },
                },
                [_vm._v("コメントを送信する")]
              ),
              _vm._v(" "),
              _c("v-btn", { on: { click: _vm.onCancel } }, [
                _vm._v("キャンセル"),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }